import { useContext } from 'react';

import { ProfileFreeSaleLinkContext, FreeSaleStatusContext, GetFreeSaleContext, FreeSaleLinkContext, IsFreeSaleContext } from '../context';

export const useProfileFreeSaleLink = () => useContext(ProfileFreeSaleLinkContext)!;
export const useFreeSaleStatus = () => useContext(FreeSaleStatusContext);
export const useGetFreeSale = () => useContext(GetFreeSaleContext)!;
export const useFreeSaleLink = () => useContext(FreeSaleLinkContext)!;
export const useIsFreeSale = () => useContext(IsFreeSaleContext)!;